// import React, { useState } from 'react';
// import { Mail, Send, ArrowRight } from 'lucide-react';
// import axios from 'axios';
// import API_URL from '../../components/config'; 
// import { useNavigate } from 'react-router-dom';

// const Contact = () => {
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState('');
//   const [submitSuccess, setSubmitSuccess] = useState('');
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     company: '',
//     inquiryType: '',
//     message: ''
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const contactMethods = [
//     {
//       icon: <Mail size={20} />,
//       title: "Email Correspondence",
//       primary: "hello@frostandgrey.com",
//       secondary: "info@frostandgrey.com",
//       description: "For inquiries and collaborations"
//     },
//   ];

//   const inquiryTypes = [
//     "Executive Training Programs",
//     "Custom Enterprise Solutions",
//     "Partnership Opportunities",
//     "Media & Press Inquiries",
//     "General Information"
//   ];

//   const validate = () => {
//     if (!formData.name.trim()) {
//       setSubmitError("Full name is required.");
//       return false;
//     }
//     if (!formData.email.trim()) {
//       setSubmitError("Email address is required.");
//       return false;
//     }
//     // Simple email regex for demonstration
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       setSubmitError("Please enter a valid email address.");
//       return false;
//     }
//     if (!formData.inquiryType.trim()) {
//       setSubmitError("Please select an inquiry type.");
//       return false;
//     }
//     if (!formData.message.trim()) {
//       setSubmitError("Please enter your message.");
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitError('');
//     setSubmitSuccess('');
//     if (!validate()) return;
//     setSubmitting(true);
//     try {
//       const res = await axios.post(`${API_URL}/api/contacts`, formData);
//       navigate('/thank-you?from=contact');
//     } catch (err) {
//       setSubmitError(
//         err.response?.data?.error ||
//         err.response?.data?.message ||
//         "Failed to send message. Please try again."
//       );
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-black text-white font-light">
//       {/* Hero Section */}
//       <div className="relative py-20 px-6">
//         <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black opacity-90"></div>
//         <div className="absolute inset-0 opacity-5">
//           <div className="w-full h-full" style={{
//             backgroundImage: `radial-gradient(circle at 30px 30px, white 2px, transparent 2px)`,
//             backgroundSize: '60px 60px'
//           }}></div>
//         </div>
//           <div className="relative z-10 max-w-4xl mx-auto text-center pt-8">
//           <p className="text-xs tracking-[0.3em] md:text-[10px] uppercase text-gray-400 mb-8">
//             Contact • Connect • Collaborate
//           </p>
//           <div className="w-px h-16 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-8"></div>
//           <p className="text-xl md:text-2xl font-light leading-relaxed max-w-3xl mx-auto tracking-wide">
//             Begin a conversation that transforms possibilities into reality.
//           </p>
//         </div>
        
//       </div>

//       {/* Form Section */}
//       <div className="bg-white text-black">
//         <div className="max-w-4xl mx-auto px-6 py-20">
//           <div className="mb-16">
//             <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">Contact Form</p>
//             <h2 className="text-4xl font-thin mb-6">
//               Send Us a
//               <br />
//               <em className="text-gray-400">Message</em>
//             </h2>
//             <div className="w-20 h-px bg-gray-300 mb-2"></div>
//             <p className="text-gray-600 font-light">We'll respond within 72 hours</p>
//           </div>

//           {/* Status Messages */}
//           {submitting && (
//             <div className="text-center text-gray-600 bg-gray-100 rounded-none py-4 mb-8 border-l-4 border-gray-400">
//               <p className="font-light tracking-wide">Sending your message...</p>
//             </div>
//           )}
//           {submitError && (
//             <div className="text-center text-red-700 bg-red-50 rounded-none py-4 mb-8 border-l-4 border-red-400">
//               <p className="font-light">{submitError}</p>
//             </div>
//           )}
//           {submitSuccess && (
//             <div className="text-center text-green-700 bg-green-50 rounded-none py-4 mb-8 border-l-4 border-green-400">
//               <p className="font-light">{submitSuccess}</p>
//             </div>
//           )}

//           <form onSubmit={handleSubmit} className="space-y-12">
//             {/* Personal Information Section */}
//             <div className="pb-8">
//               <h3 className="text-2xl font-thin mb-8 tracking-wide">Personal Details</h3>
              
//               <div className="grid md:grid-cols-2 gap-8">
//                 <div className="group">
//                   <label htmlFor="name" className="block text-gray-700 text-sm font-light mb-3 tracking-wide uppercase text-xs">
//                     Full Name <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     id="name"
//                     name="name"
//                     type="text"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     required
//                     placeholder="Enter your full name"
//                     className="w-full bg-transparent border-b border-gray-300 py-3 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light"
//                   />
//                 </div>
                
//                 <div className="group">
//                   <label htmlFor="email" className="block text-gray-700 text-sm font-light mb-3 tracking-wide uppercase text-xs">
//                     Email Address <span className="text-red-500">*</span>
//                   </label>
//                   <input
//                     id="email"
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     required
//                     placeholder="your.email@company.com"
//                     className="w-full bg-transparent border-b border-gray-300 py-3 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Company Information Section */}
//             <div className="pb-8">
//               <h3 className="text-2xl font-thin mb-8 tracking-wide">Organization Details</h3>
              
//               <div className="space-y-8">
//                 <div className="group">
//                   <label htmlFor="company" className="block text-gray-700 text-sm font-light mb-3 tracking-wide uppercase text-xs">
//                     Company/Organization
//                   </label>
//                   <input
//                     id="company"
//                     name="company"
//                     type="text"
//                     value={formData.company}
//                     onChange={handleInputChange}
//                     placeholder="Your company name"
//                     className="w-full bg-transparent border-b border-gray-300 py-3 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light"
//                   />
//                 </div>

//                 <div className="group">
//                   <label htmlFor="inquiryType" className="block text-gray-700 text-sm font-light mb-3 tracking-wide uppercase text-xs">
//                     Inquiry Type <span className="text-red-500">*</span>
//                   </label>
//                   <select
//                     id="inquiryType"
//                     name="inquiryType"
//                     value={formData.inquiryType}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full bg-transparent border-b border-gray-300 py-3 text-black focus:outline-none focus:border-black transition-all duration-300 font-light"
//                   >
//                     <option value="" className="bg-white text-gray-400">Select inquiry type</option>
//                     {inquiryTypes.map((type, idx) => (
//                       <option key={idx} value={type} className="bg-white text-black">{type}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>

//             {/* Message Section */}
//             <div className="space-y-8">
//               <h3 className="text-2xl font-thin mb-8 tracking-wide">Your Message</h3>
              
//               <div className="group">
//                 <label htmlFor="message" className="block text-gray-700 text-sm font-light mb-3 tracking-wide uppercase text-xs">
//                   Message <span className="text-red-500">*</span>
//                 </label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleInputChange}
//                   rows={6}
//                   required
//                   placeholder="Tell us about your project or inquiry..."
//                   className="w-full bg-transparent border border-gray-300 p-4 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light resize-none"
//                 />
//               </div>
//             </div>

//             {/* Submit Section */}
//             <div className="pt-12 text-center">
//               <button
//                 type="submit"
//                 disabled={submitting}
//                 className="group bg-black text-white px-16 py-4 text-sm tracking-[0.2em] uppercase hover:bg-gray-800 transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
//               >
//                 <span className="flex items-center justify-center gap-3">
//                   <Send size={18} />
//                   {submitting ? "Sending Message..." : "Send Message"}
//                   <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
//                 </span>
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>

//       {/* Contact Methods Section */}
//       <div className="bg-gray-100 text-black py-10 px-6">
//         <div className="max-w-4xl mx-auto">
//           <div className="space-y-6">
//             {contactMethods.map((method, idx) => (
//               <div key={idx} className="group border-b border-gray-200 pb-8">
//                 <div className="flex items-start gap-4">
//                   <div className="text-gray-600 group-hover:text-black transition-colors mt-1">
//                     {method.icon}
//                   </div>
//                   <div className="flex-1">
//                     <h3 className="text-black font-light text-xl mb-3 tracking-wide">{method.title}</h3>
//                     <p className="text-black font-medium mb-1 text-lg">{method.primary}</p>
//                     <p className="text-gray-600 text-sm mb-2">{method.secondary}</p>
//                     <p className="text-gray-500 text-sm tracking-wide">{method.description}</p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>


//       {/* FAQ Section */}
//       <div className="bg-white text-black py-20 px-6">
//         <div className="max-w-4xl mx-auto">
//           <div className="mb-16">
//             <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">Frequently Asked</p>
//             <h2 className="text-4xl font-thin mb-6">
//               <em className="text-gray-400">Questions</em>
//             </h2>
//             <div className="w-20 h-px bg-gray-300 mb-8"></div>
//           </div>

//           <div className="space-y-8">
//             {[
//               {
//                 question: "How quickly can we start a custom program?",
//                 answer: "Custom programs can typically begin within 4-6 weeks of initial consultation, depending on scope and requirements."
//               },
//               {
//                 question: "Do you offer international delivery?",
//                 answer: "Yes, we deliver programs globally through our hybrid model combining in-person and virtual components."
//               },
//               {
//                 question: "What is your approach to program customization?",
//                 answer: "Each program is tailored to your organization's specific needs, culture, and strategic objectives through our comprehensive discovery process."
//               },
//               {
//                 question: "How do you measure program success?",
//                 answer: "We establish clear KPIs during the planning phase and provide ongoing measurement through our proprietary assessment framework."
//               }
//             ].map((faq, idx) => (
//               <div key={idx} className="border-b border-gray-200 pb-8">
//                 <h3 className="text-lg font-light text-gray-900 mb-4 tracking-wide">{faq.question}</h3>
//                 <p className="text-gray-600 font-light leading-relaxed">{faq.answer}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="bg-gray-100 py-10 px-6 text-black">
//         <div className="max-w-4xl mx-auto text-center">
//           <div className="text-6xl font-thin text-gray-800 mb-6">"</div>
//           <blockquote className="text-2xl md:text-3xl font-light leading-relaxed tracking-wide">
//             Great conversations begin with great questions.
//             <em className="text-gray-400"> Let's start the dialogue.</em>
//           </blockquote>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact


import React, { useState } from 'react';
import { Mail, Send, ArrowRight } from 'lucide-react';
import axios from 'axios';
import API_URL from '../../components/config'; 
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    inquiryType: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Clear error on any change
    setSubmitError('');
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const contactMethods = [
    {
      icon: <Mail size={20} />,
      title: "Email Correspondence",
      primary: "hello@frostandgrey.com",
      secondary: "info@frostandgrey.com",
      description: "For inquiries and collaborations"
    },
  ];

  const inquiryTypes = [
    "Executive Training Programs",
    "Custom Enterprise Solutions",
    "Partnership Opportunities",
    "Media & Press Inquiries",
    "General Information"
  ];

  const validate = () => {
    if (!formData.name.trim()) {
      setSubmitError("Full name is required.");
      return false;
    }
    if (!formData.email.trim()) {
      setSubmitError("Email address is required.");
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setSubmitError("Please enter a valid email address.");
      return false;
    }
    if (!formData.inquiryType.trim()) {
      setSubmitError("Please select an inquiry type.");
      return false;
    }
    if (!formData.message.trim()) {
      setSubmitError("Please enter your message.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    if (!validate()) return;

    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/contacts`, formData);
      navigate('/thank-you?from=contact');
    } catch (err) {
      setSubmitError(
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Failed to send message. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white font-light">
      {/* Hero Section */}
      <div className="relative py-20 px-6">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black opacity-90"></div>
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `radial-gradient(circle at 30px 30px, white 2px, transparent 2px)`,
              backgroundSize: '60px 60px'
            }}
          ></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto text-center pt-8">
          <p className="text-xs tracking-[0.3em] md:text-[10px] uppercase text-gray-400 mb-8">
            Contact • Connect • Collaborate
          </p>
          <div className="w-px h-16 bg-gradient-to-b from-transparent via-white to-transparent mx-auto mb-8"></div>
          <p className="text-xl md:text-2xl font-light leading-relaxed max-w-3xl mx-auto tracking-wide">
            Begin a conversation that transforms possibilities into reality.
          </p>
        </div>
      </div>

      {/* Form Section */}
      <div className="bg-white text-black">
        <div className="max-w-4xl mx-auto px-6 py-20">
          <div className="mb-16">
            <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">Contact Form</p>
            <h2 className="text-4xl font-thin mb-6">
              Send Us a
              <br />
              <em className="text-gray-400">Message</em>
            </h2>
            <div className="w-20 h-px bg-gray-300 mb-2"></div>
            <p className="text-gray-600 font-light">We'll respond within 72 hours</p>
          </div>

          {/* Status Messages */}
          {submitting && (
            <div className="text-center text-gray-600 bg-gray-100 py-4 mb-8 border-l-4 border-gray-400">
              <p className="font-light tracking-wide">Sending your message...</p>
            </div>
          )}
          {submitError && (
            <div className="text-center text-red-700 bg-red-50 py-4 mb-8 border-l-4 border-red-400">
              <p className="font-light">{submitError}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-12">
            {/* Personal Information Section */}
            <div className="pb-8">
              <h3 className="text-2xl font-thin mb-8 tracking-wide">Personal Details</h3>

              <div className="grid md:grid-cols-2 gap-8">
                <div className="group">
                  <label
                    htmlFor="name"
                    className="block text-gray-700 font-light mb-3 tracking-wide uppercase text-xs"
                  >
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your full name"
                    className="w-full bg-transparent border-b border-gray-300 py-3 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light"
                  />
                </div>

                <div className="group">
                  <label
                    htmlFor="email"
                    className="block text-gray-700 font-light mb-3 tracking-wide uppercase text-xs"
                  >
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="your.email@company.com"
                    className="w-full bg-transparent border-b border-gray-300 py-3 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light"
                  />
                </div>
              </div>
            </div>

            {/* Company Information Section */}
            <div className="pb-8">
              <h3 className="text-2xl font-thin mb-8 tracking-wide">Organization Details</h3>

              <div className="space-y-8">
                <div className="group">
                  <label
                    htmlFor="company"
                    className="block text-gray-700 font-light mb-3 tracking-wide uppercase text-xs"
                  >
                    Company/Organization
                  </label>
                  <input
                    id="company"
                    name="company"
                    type="text"
                    value={formData.company}
                    onChange={handleInputChange}
                    placeholder="Your company name"
                    className="w-full bg-transparent border-b border-gray-300 py-3 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light"
                  />
                </div>

                <div className="group">
                  <label
                    htmlFor="inquiryType"
                    className="block text-gray-700 font-light mb-3 tracking-wide uppercase text-xs"
                  >
                    Inquiry Type <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="inquiryType"
                    name="inquiryType"
                    value={formData.inquiryType}
                    onChange={handleInputChange}
                    required
                    className="w-full bg-transparent border-b border-gray-300 py-3 text-black focus:outline-none focus:border-black transition-all duration-300 font-light"
                  >
                    <option value="" className="bg-white text-gray-400">
                      Select inquiry type
                    </option>
                    {inquiryTypes.map((type, idx) => (
                      <option key={idx} value={type} className="bg-white text-black">
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Message Section */}
            <div className="space-y-8">
              <h3 className="text-2xl font-thin mb-8 tracking-wide">Your Message</h3>

              <div className="group">
                <label
                  htmlFor="message"
                  className="block text-gray-700 font-light mb-3 tracking-wide uppercase text-xs"
                >
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={6}
                  required
                  placeholder="Tell us about your project or inquiry..."
                  className="w-full bg-transparent border border-gray-300 p-4 text-black placeholder-gray-400 focus:outline-none focus:border-black transition-all duration-300 font-light resize-none"
                />
              </div>
            </div>

            {/* Submit Section */}
            <div className="pt-12 text-center">
              <button
                type="submit"
                disabled={submitting}
                className="group bg-black text-white px-16 py-4 text-sm tracking-[0.2em] uppercase hover:bg-gray-800 transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <span className="flex items-center justify-center gap-3">
                  <Send size={18} />
                  {submitting ? "Sending Message..." : "Send Message"}
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Contact Methods Section */}
      <div className="bg-gray-100 text-black py-10 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
            {contactMethods.map((method, idx) => (
              <div key={idx} className="group border-b border-gray-200 pb-8">
                <div className="flex items-start gap-4">
                  <div className="text-gray-600 group-hover:text-black transition-colors mt-1">
                    {method.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-black font-light text-xl mb-3 tracking-wide">
                      {method.title}
                    </h3>
                    <p className="text-black font-medium mb-1 text-lg">
                      <a
                        href={`mailto:${method.primary}`}
                        className="hover:underline"
                      >
                        {method.primary}
                      </a>
                    </p>
                    {method.secondary && (
                      <p className="text-gray-600 text-sm mb-2">
                        <a
                          href={`mailto:${method.secondary}`}
                          className="hover:underline"
                        >
                          {method.secondary}
                        </a>
                      </p>
                    )}
                    <p className="text-gray-500 text-sm tracking-wide">
                      {method.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white text-black py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-16">
            <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">
              Frequently Asked
            </p>
            <h2 className="text-4xl font-thin mb-6">
              <em className="text-gray-400">Questions</em>
            </h2>
            <div className="w-20 h-px bg-gray-300 mb-8"></div>
          </div>

          <div className="space-y-8">
            {[
              {
                question: "How quickly can we start a custom program?",
                answer:
                  "Custom programs can typically begin within 4-6 weeks of initial consultation, depending on scope and requirements."
              },
              {
                question: "Do you offer international delivery?",
                answer:
                  "Yes, we deliver programs globally through our hybrid model combining in-person and virtual components."
              },
              {
                question: "What is your approach to program customization?",
                answer:
                  "Each program is tailored to your organization's specific needs, culture, and strategic objectives through our comprehensive discovery process."
              },
              {
                question: "How do you measure program success?",
                answer:
                  "We establish clear KPIs during the planning phase and provide ongoing measurement through our proprietary assessment framework."
              }
            ].map((faq, idx) => (
              <div key={idx} className="border-b border-gray-200 pb-8">
                <h3 className="text-lg font-light text-gray-900 mb-4 tracking-wide">
                  {faq.question}
                </h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Closing Quote */}
      <div className="bg-gray-100 py-10 px-6 text-black">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-6xl font-thin text-gray-800 mb-6">"</div>
          <blockquote className="text-2xl md:text-3xl font-light leading-relaxed tracking-wide">
            Great conversations begin with great questions.
            <em className="text-gray-400"> Let's start the dialogue.</em>
          </blockquote>
        </div>
      </div>
    </div>
  );
};

export default Contact;
